<mat-form-field class="uhc-block" [formGroup]="selectYearFormGroup" *ngIf="show && selectedClient && isWaiverManagement()" >
  <mat-label>Policy Year</mat-label>
  <mat-select formControlName="year" (selectionChange)="setSelectedYear()">
    <mat-option *ngFor="let year of Years" [value]="year.id">
      {{year.value}}
    </mat-option>
  </mat-select>
</mat-form-field>